import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';

const UserProfileMenuButton = () =>
  import(/* webpackChunkName: "4-feat-userprofile-menubutton" */ './UserProfileMenuButton');

export default lazyLoadOnRender({ loader: UserProfileMenuButton });
